import { useAppSelector, AppState } from 'store/store';
import { createSelector } from '@reduxjs/toolkit';
import { Category } from 'services/ApiService/SgmSearch/SgmSearchApiClient';
import { SgmSearchSelectors } from 'store/Normalizr/SgmSearchSelectors';

export const extractCategoryKey = (key: string | null | undefined) => (key || '').split('.').reverse()[0];

const selectCategories = createSelector(
    [(state: AppState) => state.category.categories.data, (state: AppState) => state.entities.sgmSearch],
    (keys, sgmSearch): Category[] => SgmSearchSelectors.getCategoryArray(keys || [], sgmSearch),
);

export const useCategories = (): Category[] => useAppSelector(selectCategories);
